import { Injectable } from '@angular/core';

import { ProductActions, ProductSearchService } from '@spartacus/core';

import { CustomSearchConfig } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CustomProductSearchService extends ProductSearchService {
  search(query: string, searchConfig?: CustomSearchConfig): void {
    this.store.dispatch(
      new ProductActions.SearchProducts({
        queryText: query,
        searchConfig: searchConfig
      })
    );
  }
}
